// extracted by mini-css-extract-plugin
export default {"InlineInput":"ro7a_P","inlineInput":"ro7a_P","label":"m5mWwo"};